/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const PanelLeftRightDashed = [
  ["path", { d: "M15 10V9" }],
  ["path", { d: "M15 15v-1" }],
  ["path", { d: "M15 21v-2" }],
  ["path", { d: "M15 5V3" }],
  ["path", { d: "M9 10V9" }],
  ["path", { d: "M9 15v-1" }],
  ["path", { d: "M9 21v-2" }],
  ["path", { d: "M9 5V3" }],
  ["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2" }]
];

export { PanelLeftRightDashed as default };
//# sourceMappingURL=panel-left-right-dashed.js.map
